import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bd02d9ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "column field" };
const _hoisted_2 = { style: { "display": "flex" } };
const _hoisted_3 = {
    key: 0,
    class: "label"
};
const _hoisted_4 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_5 = {
    key: 0,
    class: "instructions"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-lg fa-cloud-upload-alt uploadingIcon" }, null, -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Uploading...")
], -1));
const _hoisted_8 = [
    _hoisted_6,
    _hoisted_7
];
const _hoisted_9 = {
    key: 1,
    class: "instructions mb-5"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-lg fa-check-circle successIcon" }, null, -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Upload Successful!")
], -1));
const _hoisted_12 = [
    _hoisted_10,
    _hoisted_11
];
const _hoisted_13 = {
    key: 2,
    class: "instructions mb-5"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Drag and Drop")
], -1));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "or", -1));
const _hoisted_16 = [
    _hoisted_14,
    _hoisted_15
];
const _hoisted_17 = { key: 3 };
const _hoisted_18 = ["for"];
const _hoisted_19 = ["id"];
const _hoisted_20 = {
    key: 4,
    class: "fileInfo"
};
import { ref } from "vue";
import { uploadFile } from "@/core/api";
import { notifyNetworkError } from "@/core/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DocumentUploadField',
    props: {
        modelValue: {},
        label: {},
        description: {},
        required: { type: Boolean },
        allowedTypes: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const inputElemId = ref('inputElemId' + Math.random()); // Need to generate a globally unique ID for this, or multiple instances of this component on a page will interfere
        const hovered = ref(false);
        const uploadInProgress = ref(false);
        const dropzoneFileElem = ref(null);
        const onDrop = (e) => {
            upload(e.dataTransfer.files[0]);
            hovered.value = false;
        };
        const onFileSelected = (e) => {
            console.log("onFileSelected", e, dropzoneFileElem.value);
            upload(dropzoneFileElem.value.files[0]);
        };
        const upload = (file) => {
            emit("update:modelValue", null);
            uploadInProgress.value = true;
            uploadFile(file, props.allowedTypes)
                .then((uploadedFile) => {
                console.log("Uploaded file", uploadedFile);
                emit("update:modelValue", uploadedFile);
                uploadInProgress.value = false;
            })
                .catch((err) => {
                notifyNetworkError("Failed to upload file", err);
                uploadInProgress.value = false;
            });
        };
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.label)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.label), 1))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "top")
                ]),
                (_ctx.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(["dropzone control", { 'activeDropzone': hovered.value, 'upload-in-progress': uploadInProgress.value }]),
                    onDragenter: _cache[0] || (_cache[0] = _withModifiers(($event) => (hovered.value = true), ["prevent"])),
                    onDragleave: _cache[1] || (_cache[1] = _withModifiers(($event) => (hovered.value = false), ["prevent"])),
                    onDragover: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"])),
                    onDrop: _withModifiers(onDrop, ["prevent"])
                }, [
                    (uploadInProgress.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
                        : (_ctx.modelValue)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                            : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16)),
                    (!uploadInProgress.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("label", {
                                for: inputElemId.value,
                                class: "uploadLabel"
                            }, _toDisplayString(_ctx.modelValue ? 'Replace File' : 'Select File'), 9, _hoisted_18),
                            _createElementVNode("input", {
                                type: "file",
                                id: inputElemId.value,
                                ref_key: "dropzoneFileElem",
                                ref: dropzoneFileElem,
                                class: "dropzoneFile",
                                onChange: onFileSelected
                            }, null, 40, _hoisted_19)
                        ]))
                        : _createCommentVNode("", true),
                    (!uploadInProgress.value && ((_a = _ctx.modelValue) === null || _a === void 0 ? void 0 : _a.filename))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.modelValue.filename), 1))
                        : _createCommentVNode("", true)
                ], 34)
            ]));
        };
    }
});
